module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Heavy.daed3d91.woff";